var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRandom1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a8d7e3;}.b{fill:#6fbdd1;}.c{fill:#5a9daf;}.d{fill:#fff;font-size:3px;font-family:SegoeUI, Segoe UI;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(95 405) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 14,
    transform: "translate(45 355)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H25V12.5H0Z",
    transform: "translate(45 367.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H25V12.5H0Z",
    transform: "translate(45 380)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H25V12.5H0Z",
    transform: "translate(45 392.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H25V12.5H0Z",
    transform: "translate(70 367.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H25V12.5H0Z",
    transform: "translate(70 380)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H25V12.5H0Z",
    transform: "translate(70 392.5)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(81 360) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini oudoing")), /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(62 385) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini")), /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(88 373) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini")), /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(62 398) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "elumini")), /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(87 385) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(60 373) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")), /*#__PURE__*/React.createElement("text", {
    className: "d",
    transform: "translate(87 398) rotate(180)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "enter")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandom1);
export default __webpack_public_path__ + "static/media/random1.fbf5cd427a21c9c8151ea8fe98eb0d38.svg";
export { ForwardRef as ReactComponent };